import * as React from 'react';
import styles from './sidebar.module.css';
import { convertStringtoDollarString } from '../../../helpers/formathelper';
import { useLead } from '../../../contexts/lead/lead.context';
import { useRisk } from '../../../contexts/risk/risk.context';
import { SidebarList } from './sidebar-list.component';

export type TStateProps = {
	subModule?: string | undefined | '';
};

export const SideBarComponent: React.FC<TStateProps> = (props: TStateProps) => {
	const { riskSidebarText } = useRisk();

	const activeState = (subM: any) => {
		return props.subModule === subM ? styles.active : styles.noactive;
	};

	return (
		<div className={styles.sideMenu}>
			<nav className={styles.sideMenuNavBar} role="navigation">
				<ul className={styles.rowFlex}>
					<SidebarList
						text={'1. Investment Return Range'}
						propsValue={riskSidebarText.investmentText}
						activeClassName={activeState('investment_return')}
					/>
					<SidebarList
						text={'2. Maximum Decline'}
						propsValue={riskSidebarText.maxDeclineText}
						activeClassName={activeState('maximum_decline')}
					/>
					<SidebarList
						text={'3. Stock Market Forecast'}
						propsValue={riskSidebarText.stockMarketText}
						activeClassName={activeState('stock_market')}
					/>
					<SidebarList
						text={'4. Your Age Range'}
						propsValue={riskSidebarText.ageRangeText}
						activeClassName={activeState('age_range')}
					/>
                    <SidebarList
						text={'5. Planned Withdrawal'}
						propsValue={riskSidebarText.withdrawalText}
						activeClassName={activeState('planned_withdrawal')}
					/>
				</ul>
			</nav>
		</div>
	);
};
